export default __webpack_public_path__ + "static/media/Belle_Niba_AHV_In_Moms_We_Trust.01f243b6.jpg";